import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';

// styles
import {
  InputBarContainer,
  InputBarControl,
  InputBarComponent,
  InputBarPrefix,
  InputBarPasswordToggle,
  InputLabel
} from './InputBar.styles.js';

export default function InputBar({
  type,
  pH="",
  value,
  updateValue,
  id,
  label,
  expands=true,
  onBlur,
  onFocus,
  prefix,
  placeholder,
  showPasswordToggle,
  selectOnFocus,
  inputMode,
  align = 'left',
  readOnly = false,
  ...otherProps
}) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const isPasswordType = type === 'password';
  const showToggle = isPasswordType && showPasswordToggle;
  const inputType = showToggle ? (isPasswordVisible ? 'text' : 'password') : type;
  const hasLabel = expands && !!(label || pH);
  const shouldSelectOnFocus = !readOnly && (selectOnFocus ?? (inputMode === 'decimal' || inputMode === 'numeric' || prefix != null));

  const handleFocus = (event) => {
    onFocus?.(event);
    if (!shouldSelectOnFocus) return;
    const target = event.target;
    // Wait a frame so this wins over the mouseup caret placement that
    // would otherwise collapse the selection on click-to-focus.
    requestAnimationFrame(() => target.select());
  };

  const isCentered = align === 'center';

  return (
      <InputBarContainer $align={isCentered ? 'center' : 'left'} $readOnly={readOnly}>
          {hasLabel && (
            <InputLabel $align={isCentered ? 'center' : 'left'}>
                {label || pH}
            </InputLabel>
          )}
          <InputBarControl>
              {prefix != null && <InputBarPrefix>{prefix}</InputBarPrefix>}
              <InputBarComponent
                  className='panel-bg'
                  type={inputType}
                  inputMode={inputMode}
                  placeholder={placeholder ?? (expands ? (pH || undefined) : (label || pH))}
                  value={value}
                  id={id}
                  $align={isCentered ? 'center' : 'left'}
                  $hasPrefix={!!prefix}
                  $hasPasswordToggle={showToggle}
                  $readOnly={readOnly}
                  readOnly={readOnly}
                  {...otherProps}
                  onChange={(e) => updateValue(e.target.value)}
                  onBlur={onBlur}
                  onFocus={handleFocus}
              />
              {showToggle && (
                <InputBarPasswordToggle
                  type="button"
                  onClick={() => setIsPasswordVisible((v) => !v)}
                  aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}
                >
                  {isPasswordVisible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </InputBarPasswordToggle>
              )}
          </InputBarControl>
      </InputBarContainer>
  )
}
